import React from "react";
import { IoClose } from "react-icons/io5";
import { MapPin, Locate } from "lucide-react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const MapModal = ({ isOpen, onClose, address, actualAddress }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_API_KEY, // your API key
  });

  if (!isOpen || !address?.latitude || !address?.longitude) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-[90%] md:w-[80%] lg:w-[70%] h-[80vh] md:h-[85vh] lg:h-[90vh] mx-4 overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-xl md:text-2xl font-semibold">
            Location Preview
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            <IoClose size={24} />
          </button>
        </div>

        {/* Google Map */}
        <div className="flex-1 w-full">
          {!isLoaded ? (
            <div className="flex items-center justify-center h-full text-gray-500">
              Loading Map...
            </div>
          ) : (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={{
                lat: Number(address.latitude),
                lng: Number(address.longitude),
              }}
              zoom={16}
            >
              <Marker
                position={{
                  lat: Number(address.latitude),
                  lng: Number(address.longitude),
                }}
              />
            </GoogleMap>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 flex flex-col md:flex-row justify-between items-center px-4 py-3 gap-4 mb-4">
          <div className="flex gap-4 items-center">
            <div className="h-10 w-10 bg-[#FF6943]/20 rounded-md flex justify-center items-center p-1">
              <MapPin size={18} className="text-orange-500" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Delivery Address</p>
              <p className="text-sm text-orange-500 font-bold">
                {actualAddress}
              </p>
            </div>
          </div>

          <button
            className="flex items-center gap-2 px-5 py-2 bg-[#FF6943] text-white rounded-md hover:bg-orange transition"
            onClick={() =>
              window.open(
                `https://www.google.com/maps?q=${address.latitude},${address.longitude}`,
                "_blank",
              )
            }
          >
            <Locate /> Open in Google Maps
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapModal;
